import {Injectable} from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate, Router, RouterStateSnapshot
} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {AuthService} from "../services/common/auth.service";
import {DataService} from "../services/common/data.service";
import {DemoService} from "../services/common/demo.service";
import {ViewService} from "../services/common/view.service";

@Injectable({
  providedIn: 'root'
})
export class IsLoggedGuard implements CanActivate {
  lang: any;
  constructor(
    private router: Router,
    private data: DataService,
    private demo: DemoService,
    private view: ViewService,
    private translate: TranslateService
  ){
    this.translate.get('TOPBAR').subscribe((lang: any) => {
      this.lang = lang;
    });
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    if(!AuthService.isLogged){

      /** In demo la rotta resta negata (le rotte ammesse hanno DemoOrLoggedGuard,
       *  non questo) ma va spiegato il perché: mandare al login farebbe pensare
       *  di essere stati sloggati, e il redirect muto sembra un bug.
       *  Ritornando false senza navigare l'utente resta sulla pagina da cui ha
       *  cliccato; l'unico caso in cui serve il redirect è l'ingresso diretto
       *  da URL, dove non c'è nessuna pagina su cui restare. */
      if(DemoService.active){
        const buttons: any[] = [{
          label: this.lang.chiudi, color: 'danger'
        }, {
          label: this.lang.vai_al_login, click: () => {
            this.router.navigate(['/login'], {
              queryParams: {isDemo: true, idBrowser: this.demo.idBrowser},
              replaceUrl: true
            });
          }
        }];
        this.view.modalAlert(this.lang.attenzione, this.lang.devi_essere_loggato, 'warn', buttons);
        if(!this.router.navigated) this.router.navigate(['/map'], {replaceUrl: true});
        return false;
      }

      this.router.navigate(['/login'], {replaceUrl: true});
      return false;
    }else{
      return true;
    }
  }

}
